import { SET_POPUP, CLOSE_POPUP } from './types'

export const setPopup = (payload) => ({
  type: SET_POPUP,
  payload,
})

export const closePopup = () => ({
  type: CLOSE_POPUP,
})
